var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBznavTitle = function SvgBznavTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 28,
    fill: "none",
    viewBox: "0 0 71 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4939F3"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.32 5.406H7.742v5.16H2.578v-5.16H0v14.44h10.32zm-7.735 12.2v-4.983h5.164v4.982z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.763 4.2v19.6h2.578V4.2zM42.152 13.829h4.168c1.813 0 3.607-.132 4.946-.31v-2.043c-1.339.178-3.133.29-4.788.29h-1.747V4.372h-2.579z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M59.35 23.629v-8.423h-2.578v2.063H46.623v-2.063h-2.407v8.423zm-2.578-2.063H46.623v-2.063h10.15z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.859 7.298V9.36h3.785v5.153h2.579V4.372h-2.579v2.926zM59.35 14.514V4.2h-2.578v10.314zM70.7 4.2v7.823L62.872 4.2zM19.784 19.325h19.269v2.063h-19.27zM21.676 16.056l-1.068-2.003c4.65-1.173 7.603-3.52 7.603-6.834v-.277h-6.535V4.886H37.16v2.062h-6.363v.159c0 3.334 2.954 5.66 7.603 6.834l-1.068 2.003c-3.324-.83-6.206-2.557-7.788-4.83-1.583 2.32-4.491 4.073-7.861 4.949z"
  }))));
};
export default SvgBznavTitle;